import { render } from "./AccountMenu.vue?vue&type=template&id=443d6f90&scoped=true"
import script from "./AccountMenu.vue?vue&type=script&lang=js"
export * from "./AccountMenu.vue?vue&type=script&lang=js"

import "./AccountMenu.vue?vue&type=style&index=0&id=443d6f90&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/ShelfDat/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443d6f90"]])

export default __exports__